/** The palettes and the hash Discover's covers and hero pick their colours by. */
export function hashStr(s: string): number {
    let h = 5381;
    for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0; // NOSONAR typescript:S7767 false-positive: | 0 is the djb2 hash's 32-bit wrap; Math.trunc does not wrap and would change every Discover cover's colours
    return Math.abs(h);
}

export const HERO_PALETTES: [string, string, string][] = [
    ['#0ea5e9', '#6366f1', '#a855f7'],
    ['#f97316', '#ec4899', '#a855f7'],
    ['#10b981', '#06b6d4', '#3b82f6'],
    ['#f59e0b', '#ef4444', '#ec4899'],
    ['#22d3ee', '#3b82f6', '#8b5cf6'],
];
